/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ticketsinvoicevatunset3Inputs */

const en_ticketsinvoicevatunset3 = /** @type {(inputs: Ticketsinvoicevatunset3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please choose`)
};

const de_ticketsinvoicevatunset3 = /** @type {(inputs: Ticketsinvoicevatunset3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bitte wählen`)
};

/**
* | output |
* | --- |
* | "Please choose" |
*
* @param {Ticketsinvoicevatunset3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const ticketsinvoicevatunset3 = /** @type {((inputs?: Ticketsinvoicevatunset3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticketsinvoicevatunset3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticketsinvoicevatunset3(inputs)
	return de_ticketsinvoicevatunset3(inputs)
});
export { ticketsinvoicevatunset3 as "ticketsInvoiceVatUnset" }